// import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";

export const GridConfig = {
	list: BaseModelInvestment.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly:false
		},
		InvestmentID: {
			class: 'value',
			dataName: 'InvestmentID',
			type: 'number',
			title: 'Investment ID',
			width: 120,
			hidden: false,
			readOnly:false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Investment Name',
			width: 150,
			hidden: false,
			readOnly:false,
		},
		// InvestmentGroup: {
		// 	class: 'choice',
		// 	dataName: 'InvestmentGroup',
		// 	type: 'string',
		// 	title: 'Investment Group',
		// 	width: 220,
		// 	hidden: false,
		// 	readOnly: false
		// },
		// StatementOrder: {
		// 	class: 'value',
		// 	dataName: 'StatementOrder',
		// 	type: 'number',
		// 	title: 'Statement Order',
		// 	width: 140,
		// 	hidden: false,
		// 	readOnly:false
		// },		
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'currency',
			title: 'Projected Value',
			//template: '#=kendo.toString(ProjectedValue, "c")#',
			//template: '#if(ProjectedValue === null){##}else{# #=kendo.toString(ProjectedValue, "c")#  #}#',
			template: '<span class="number-cell-ui">#if(ProjectedValue === null){##}else{# #=kendo.toString(ProjectedValue, "c")#  #}#</span>',
			width: 140,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'currency',
			title: 'Current Value',
			//template: '#=kendo.toString(CurrentValue, "c")#', 
			//template: '#if(CurrentValue === null){##}else{# #=kendo.toString(CurrentValue, "c")#  #}#', 
			template: '<span class="number-cell-ui">#if(CurrentValue === null){##}else{# #=kendo.toString(CurrentValue, "c")#  #}#</span>', 
			width: 140,
			hidden: false,
			readOnly: false
		},
		// Note: {
		// 	class: 'value',
		// 	dataName: 'Note',
		// 	type: 'string',
		// 	title: 'Note',
		// 	width: 100,
		// 	hidden: false,
		// 	readOnly:false
		// }
	},
	grid: {
		gridId:'InvestmentValuationGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: false,
		document: true,
		groupable: true,
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [         
			{
				template: `<Label style="width:110px;">Select Period: </Label>
				<div id="kendo-select"><input id="dropdownPeriod" style="width:120px;" /></div>`, 
				overflow: "never" 

					// template: `<Label style="width:200px;">Select Period: </Label>
					// <select id="dropdownPeriod" class="form-control">
					// </select>`, 
					
			}, 
			// {
			// 		id:"btnAddInvestment",
			// 		type: "button",
			// 		text: "Add Investment",
			// 		showIcon: "toolbar",
			// 		icon:"plus-circle",
			// 		attributes: { "class": "float-right-btn btn btn-primary" },
					
			// } ,
			// {
			// 	id:"backTo",
			// 	type: "button",
			// 	text: "Back to Initial Issuance",
			// 	showIcon: "toolbar",
			// 	attributes: { "class": "float-right-btn btn btn-secondary d-none" },
			// } ,
			{
                id:"btnBulkImportUnitInvestmentValuation",
                type: "button",
                text: "Bulk Import",
                showIcon: "toolbar",
                icon:"upload",
                attributes: { "class": "float-right-btn btn btn-primary" },
                
            }      
			 
	]
}